//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed, defineComponent, onMounted, ref, toRefs } from "@vue/composition-api";
import { useApplicationStoreGetters, useApplicationStoreActions } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import * as LenderSubmitGetters from "@Broker/@Modules/clients/applications/application/store/lender-submit-getters";
import * as LenderSubmitActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import ParticipantsCoBrokerLoader from "./participants-co-broker-loader.vue";
import { useI18n } from "vue-i18n-composable";
import { formatDate } from "@Shared/@Utils/helpers/dates";
export default defineComponent({
  name: "ParticipantsCoBroker",
  components: {
    ParticipantsCoBrokerLoader
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const {
      applicationId,
      clientUsername
    } = toRefs(props);
    const {
      LOAD_CO_BROKERING_HISTORY
    } = useApplicationStoreActions([LenderSubmitActions.LOAD_CO_BROKERING_HISTORY]);
    const {
      CO_BROKERING_HISTORY
    } = useApplicationStoreGetters([LenderSubmitGetters.CO_BROKERING_HISTORY]);
    const loadingHistory = ref(false);
    const {
      t
    } = useI18n();
    onMounted(async () => {
      loadingHistory.value = true;
      await LOAD_CO_BROKERING_HISTORY({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value
      });
      loadingHistory.value = false;
    });
    const tableOptions = computed(() => {
      return {
        filterable: false,
        sortable: ["expirationDate"],
        columns: ["date", "mortgageType", "mortgageAmount", "submittedTo", "brokerage", "status"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        headings: {
          date: t("global.words.date"),
          mortgageType: t("application-form.mortgage-type"),
          mortgageAmount: t("global.doorr.mortgageAmount"),
          submittedTo: t("direct-to-lender.participants.submittedTo"),
          brokerage: t("global.doorr.brokerage"),
          status: t("global.words.status")
        },
        skin: "table table-hover",
        perPage: 999999,
        texts: {
          noResults: t("direct-to-lender.participants.noCoBrokeringHistory")
        }
      };
    });
    return {
      loadingHistory,
      CO_BROKERING_HISTORY,
      tableOptions,
      formatDate
    };
  }
});